import React, { useState } from 'react';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { FiFileText, FiHeadphones, FiHeart, FiVideo } from 'react-icons/fi';
import { PiFilePdf } from 'react-icons/pi';
import { FinderFavoriteIcon } from '@/components/custom/finder';
import { Button } from '@/components/ui/button';
import { TableCell, TableRow, TableUser, TableUserContent, TableUserTitle } from '@/components/ui/table';
import { IconWrapper } from '@/components/custom/icon';

export function LessonPlanRowMaterial({ material }) {
  const client = useClient();
  const [isFavorite, setIsFavorite] = useState(material?.was_favorited);

  async function handleFavorite(id) {
    await client
      .mutate(`/class_plans/${id}`, {
        favorite: !isFavorite
      })
      .then(() => {
        setIsFavorite(prev => !prev);
      })
      .catch(error => {
        console.error(error);
        toast.error(isFavorite ? 'Erro ao remover favorito' : 'Erro ao favoritar');
      });
  }

  const materialFileUrl = material?.file?.url;

  const isPdf = materialFileUrl.includes('.pdf');
  const isVideo = materialFileUrl.includes('.mp4');
  const isAudio = materialFileUrl.includes('.mp3');

  function MaterialIcon() {
    if (isPdf) return <PiFilePdf className="card__icon" />;
    if (isVideo) return <FiVideo className="card__icon" />;
    if (isAudio) return <FiHeadphones className="card__icon" />;

    return <FiFileText className="card__icon" />;
  }

  return (
    <TableRow>
      <TableCell>
        <TableUser>
          <IconWrapper>
            <MaterialIcon />
          </IconWrapper>

          <TableUserContent>
            <TableUserTitle title={material?.title}>{material?.title}</TableUserTitle>
          </TableUserContent>
        </TableUser>
      </TableCell>

      <TableCell>{material?.shift}</TableCell>

      <TableCell>{material?.month}</TableCell>

      <TableCell>
        <Button
          variant="outline"
          size="xs"
          fullWidth
          asChild
        >
          <a
            href={material?.file?.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download
          </a>
        </Button>
      </TableCell>

      <TableCell>
        <FinderFavoriteIcon isActive={isFavorite}>
          <FiHeart onClick={() => handleFavorite(material?.id)} />
        </FinderFavoriteIcon>
      </TableCell>
    </TableRow>
  );
}
